export const CHANNEL_KEYS = ["call", "sms", "whatsapp", "email"] as const;
export type ChannelKey = (typeof CHANNEL_KEYS)[number];
export type ChannelFlags = Record<ChannelKey, boolean>;

export const canSeeEmailChannel = (
  user?: { is_super_admin?: boolean } | null
): boolean => Boolean(user?.is_super_admin);

export const DEFAULT_CHANNEL_FLAGS: ChannelFlags = {
  call: true,
  sms: false,
  whatsapp: false,
  email: false,
};

export const normalizeChannelFlags = (
  input?: Partial<ChannelFlags> | null
): ChannelFlags => ({
  call: input?.call !== false,
  sms: input?.sms === true,
  whatsapp: input?.whatsapp === true,
  email: input?.email === true,
});

export const firstEnabledChannel = (
  flags: ChannelFlags,
  preferred: readonly ChannelKey[] = CHANNEL_KEYS
): ChannelKey => preferred.find((key) => flags[key]) || "call";

export interface ICompany {
  _id: string;
  name: string;
  settings?: {
    channels?: Partial<ChannelFlags>;
    sip?: {
      domain?: string;
      agent_id?: string;
      front_desk_uri?: string;
    };
  };
}

export interface ICompanySelection {
  company_id: string;
}
